define([
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/xml"
], function(Action,ActionFactory,xml) {

	return ActionFactory.declare("EditAll", Action, {
		constructor: function(obj) {
			this.m_tag ||= "EditAll";

			this.setBaseRights(null, xml.RIGHT_WRITE);
		}
	});
});